import type { PropsWithChildren, ReactNode } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'
import clsx from 'clsx'

const Layout = styled.div`
  display: grid;
  min-width: 0;
  gap: ${rem(16)};

  ${mediaQueryUp.desktop} {
    gap: 0;
    align-items: stretch;
    border: 1px solid var(--palette-neutral-surface-light-foreground, ${props => props.theme.palette.neutral.surface.lightForeground});
    border-radius: ${props => props.theme.borderRadius.M};

    &.has-summary {
      grid-template-columns: minmax(0, 1fr) clamp(${rem(220)}, 17.3%, ${rem(244)});
    }
  }
`

const Rooms = styled.div`
  min-width: 0;
  display: grid;
  gap: ${rem(20)};
  align-content: start;
  border-start-start-radius: inherit;
  border-end-start-radius: inherit;

  ${mediaQueryUp.desktop} {
    > :first-child {
      border-start-start-radius: inherit;
    }
    > :last-child {
      border-end-start-radius: inherit;
    }
    > :not(:first-child) {
      border-top: 1px solid var(--palette-neutral-surface-light-foreground, ${props => props.theme.palette.neutral.surface.lightForeground});
    }
    > :not(:last-child) {
      border-bottom: 1px solid var(--palette-neutral-surface-light-foreground, ${props => props.theme.palette.neutral.surface.lightForeground});
    }
  }
`

const Summary = styled.aside`
  min-width: 0;

  ${mediaQueryUp.desktop} {
    align-self: stretch;
    background-color: ${props => props.theme.palette.neutral.surface.normalBackground};
    border-inline-start: 1px solid var(--palette-neutral-surface-light-foreground, ${props => props.theme.palette.neutral.surface.lightForeground});
    border-start-end-radius: ${props => props.theme.borderRadius.M};
    border-end-end-radius: ${props => props.theme.borderRadius.M};
  }
`

const SummaryContent = styled.div`
  ${mediaQueryUp.desktop} {
    position: sticky;
    top: ${rem(88)};
  }
`

interface Props extends PropsWithChildren {
  summary?: ReactNode
}

function AccommodationPackageSelectionLayout({ children, summary }: Props) {
  return <Layout className={clsx({ 'has-summary': !!summary })}>
    <Rooms>{children}</Rooms>
    {summary && <Summary><SummaryContent>{summary}</SummaryContent></Summary>}
  </Layout>
}

export default AccommodationPackageSelectionLayout
